import { render, staticRenderFns } from "./SalaryTaxRoles.vue?vue&type=template&id=17929e88&scoped=true"
import script from "./SalaryTaxRoles.vue?vue&type=script&lang=js"
export * from "./SalaryTaxRoles.vue?vue&type=script&lang=js"
import style0 from "./SalaryTaxRoles.vue?vue&type=style&index=0&id=17929e88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17929e88",
  null
  
)

export default component.exports